import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    description: translate({ id: 'supportTicket.warningCard.description' }),
  }))

  return api
}
